
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/content-migrations/jst/subviews/FolderPicker';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function";


  buffer += "<label class=\"control-label\"><strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.folder_picker")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.folder_picker.upload_to", "Upload to", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.folder_picker.upload_to", "Upload to", options)))
    + "</strong></label>\n<div class=\"controls\">\n  <select class=\"migrationUploadTo span3\" name=\"migrationUploadTo\">\n    <option value=\"\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.folder_picker")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.folder_picker.default_select_folder", "Select Folder", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.folder_picker.default_select_folder", "Select Folder", options)))
    + "</option>\n    ";
  if (helper = helpers.folderOptions) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.folderOptions); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </select>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  